<section class="flex flex-col items-center gap-12 text-center" id="faq">
  <app-section-header [title]="'Frequently asked questions'">
    <p #description>
      Have questions about migrating from Ionic Appflow to Capawesome Cloud?
      We've answered the most common migration questions here. For additional
      support, reach out to us by
      <a [href]="'mailto:' + emailSupport" target="_blank">Email</a> or via
      <a [href]="discordUrl" target="_blank">Discord</a>.
    </p>
  </app-section-header>
  <app-faq-accordion [items]="items" class="w-full lg:w-[1024px]" />
</section>
